module.exports = __webpack_public_path__ + "img/arrow-select-down.d0e95151.svg";